import { render } from "./BubbleDraw2.vue?vue&type=template&id=426c99b8"
import script from "./BubbleDraw2.vue?vue&type=script&lang=js"
export * from "./BubbleDraw2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__